import { omit, pick } from 'lodash'
import { useState, useEffect } from 'react'
import {
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Button,
  Stack,
  Box,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DeleteOutline as DeleteIcon, SaveOutlined as SaveIcon, } from '@mui/icons-material'
import * as action from 'store/settings/role'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Header from 'components/Header'

function RoleEdit({ role, onClose }) {
  const { t } = useTranslation()
  const [state, setState] = useState({ id: 0, name: '', enabled: true })
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    setState(role ? pick(role, ['id', 'name', 'enabled']) : { id: 0, name: '', enabled: true })
  }, [role])

  const handleChange = event => {
    let { name, value, checked } = event.target
    if (name === 'enabled') value = checked
    setState(prev => ({ ...prev, [name]: value }))
  }

  const onDestroyClick = async () => {
    const { payload, error } = await dispatch(action.destroy({ id: state.id }))
    if (payload && !error) { onClose?.(); navigate('/permission') }
  }

  const onSubmit = async () => {
    const id = state.id
    const { payload, error } = await dispatch(id > 0 ? action.update(state) : action.create(omit(state, 'id')))
    if (!error && payload) {
      onClose?.()
      navigate(['/permission', payload.id].join('/'))
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column',  }}>
      <Header
        title={state.id > 0 ? t('Edit Role') : t('New Role')}
        close={onClose}
        small
        borderBottom
      />

      <Box sx={{ p: 3, flexGrow: 1 }}>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={12}>
            <TextField
              fullWidth
              size="small"
              name="name"
              variant="outlined"
              label={t('Role Name')}
              placeholder={t('e.g., Administrator')}
              value={state.name || ''}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ border: '1px solid', borderColor: 'divider', px: 2, py: 1, borderRadius: 1 }}>
              <FormControlLabel
                control={<Switch size="small" checked={state.enabled ?? true} onChange={handleChange} name="enabled"  />}
                label={<Typography variant="body1" fontWeight={400}>{t('Active')}</Typography>}
                sx={{ ml: 0, width: '100%', justifyContent: 'space-between' }}
                labelPlacement="start"
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
        <Button size="small" color="error" variant="outlined" onClick={onDestroyClick} startIcon={<DeleteIcon />} disabled={state.id === 0}>
          {t('Delete')}
        </Button>
        <Button variant="contained" size="small" disableElevation onClick={onSubmit} startIcon={<SaveIcon />}>
            {t('Save Changes')}
          </Button>
        </Stack>
  
    </Box>
  )
}

export default RoleEdit